import environments from "../../../../environments";
import { IProperty } from "../../../../shared/interfaces/IProperties";
import { AraucariaUsoSolo } from "./providers/araucaria";
import { CarambeiUsoSolo } from "./providers/carambei";
import { IpirangaUsoSolo } from "./providers/ipiranga";
import { JczUsoSolo } from "./providers/jcz";
import { StandardUsoSolo } from "./providers/standard";

interface Props {
    propertyInfo?: IProperty;
}

export const UsoSolo: React.FC<Props> = ({ propertyInfo }) => {
    switch (environments.client.name) {
        case "carambei":
            return <CarambeiUsoSolo propertyInfo={propertyInfo} />;
        case "jcz":
            return <JczUsoSolo propertyInfo={propertyInfo} />;
        case "ipiranga":
            return <IpirangaUsoSolo propertyInfo={propertyInfo} />;
        case "araucaria":
            return <AraucariaUsoSolo propertyInfo={propertyInfo} />;
        default:
            return <StandardUsoSolo propertyInfo={propertyInfo} />;
    }
};
